<ng-scrollbar #scrollable track="all">
    <div *ngIf="!loader" class="vh-100 py-0 px-3" style="min-height: 560px">

        <div class="d-inline mb-2">
            <label class="text-uppercase"
                   style="font-weight: 600;">
                {{board.name}}
            </label>
        </div>
        <div class="d-inline ml-3">
            <button [title]="'Podešavanje statusa'"
                    (click)="openStatusSettings()"
                    class="btn btn-primary btn-sm board-button cursor"
                    type="button">
                ...
            </button>
        </div>


        <div class="vh-100 row col-sm-12 d-block board-example-list"
             cdkDropListOrientation="horizontal"
             cdkDropList
             (cdkDropListDropped)="dropColumns($event)">
            <div class="board-example-box"
                 style="position: absolute"
                 cdkDropListGroup>
                <div cdkDrag
                     class="board-example-container"
                     [cdkDragData]="items"
                     *ngFor="let items of list;index as i">
                    <div class="row">
                        <div class="d-inline p-2"><h3 #ignoredButton
                                                      (click)="items.toggle=!items.toggle"
                                                      [id]="items.head"
                                                      class="board-column-header mr-3 mb-4"
                                                      [ngStyle]="{'background':items.color, 'border': '1px solid '+ items.color}"
                                                      [style.background]="color"
                                                      #ignoredInput
                                                      (colorPickerChange)="items.color=$event;colorPickerHandler($event, items.id)"
                                                      [cpOKButton]="true"
                                                      [cpOKButtonClass]="'btn btn-primary btn-xs'"
                                                      [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                                                      [(cpToggle)]="items.toggle"
                                                      [(colorPicker)]="items.color">
                            {{items.head}}
                        </h3></div>
                        <div class="d-inline p-2 bg-dark text-white">d-inline</div>
                    </div>


                    <h3 #ignoredButton
                        (click)="items.toggle=!items.toggle"
                        [id]="items.head"
                        class="board-column-header mr-3 mb-4"
                        [ngStyle]="{'background':items.color, 'border': '1px solid '+ items.color}"
                        [style.background]="color"
                        #ignoredInput
                        (colorPickerChange)="items.color=$event;colorPickerHandler($event, items.id)"
                        [cpOKButton]="true"
                        [cpOKButtonClass]="'btn btn-primary btn-xs'"
                        [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                        [(cpToggle)]="items.toggle"
                        [(colorPicker)]="items.color">
                        {{items.head}}
                    </h3>


                    <div cdkDropList
                         [id]="items.id"
                         #todoList="cdkDropList"
                         cdkDropListOrientation="horizontal"
                         [cdkDropListData]="items.items"
                         class="board-example-list"
                         (cdkDropListDropped)="drop($event)"
                         [cdkDropListConnectedTo]="trackIds">
                        <div [cdkDragData]="task._id"
                             class="board-example-box board-task-card mb-3"
                             *ngFor="let task of items.items"
                             cdkDrag>

                            <div [routerLink]="['/view-task',task['_id']]"
                                 class="card-body board-task">
                                <div class="float-right mt-n1 mb-2"
                                     style="width: 100%">
                                    <div class="media">
                                        <div class="media-body mr-2">
                                            <h4 class="mt-0"
                                                style="word-break: break-all">
                                                {{task['title']}}</h4>
                                        </div>
                                        <app-avatar
                                                [personalStyle]="task['type']==='meeting'? 'margin-top:4px;border: 2px solid white;left: 3%;':'margin-top:4px;border:2px solid white'"
                                                [avatarWidth]="30"
                                                [assigned]="assign"
                                                *ngFor="let assign of task.assigned"></app-avatar>

                                    </div>
                                </div>
                                <div class="kanban-card-tags">
                                <span style="background: #4bc66c"
                                      class="badge badge-success "
                                      [ngClass]="{'ml-1':i>0}"
                                      *ngFor="let tag of task['tags'];index as i">
                                    {{tag}}
                                </span>
                                </div>
                                <div class="card-footer no-border bg-transparent kanban-card-attachments no-padding-left text-right no-padding-right">
                                    <div class="full-width" id="homethumbs">
                                        <div class="wrap"
                                             style="display: inline-flex;
    float: right;">
                                            <div class="homethumb board-task-details">
                                            <span title="Podzadaci"
                                                  class="badge badge-info ml-1"
                                                  style="margin-top: 2px;margin-right: 5px;">
                                            <i class="lni lni-list"></i>
                                                {{task.subtasks.length}}
                                            </span>
                                            </div>
                                            <div class="homethumb board-task-details">
                                            <span title="Dokumenti" class="badge badge-success">
                                             <i class="lni lni-paperclip"></i>
                                                {{task.attachments.length}}
                                            </span>
                                            </div>
                                            <div class="homethumb board-task-details">
                                            <span title="Komentari" class="badge badge-success ml-1">
                                                <i class="lni lni-comments"></i>
                                                {{task.comments}}
                                            </span>
                                            </div>
                                            <div class="homethumb board-task-details">
                                            <span *ngIf="task.dayPast <0"
                                                  title="Rok je istekao pre {{task.dayPast * -1}} dana"
                                                  class="badge badge-danger ml-1"
                                                  style="margin-top: 2px;pointer-events: none;background: #f4433685;">
                                                {{task.dayPast * -1}} dana
                                                </span>
                                                <span *ngIf="task.dayPast > 0"
                                                      title="{{task.dayPast}} dana do kraja roka"
                                                      class="badge badge-success ml-1 mr-1"
                                                      style="margin-top: 2px;pointer-events: none">
                                                    {{task.dayPast}} dana
                                                </span>
                                                <span *ngIf="task.dayPast == 0" title=" Danas ističe rok."
                                                      class="badge badge-info ml-1"
                                                      style="margin-top: 2px;pointer-events: none">
                                                        Danas
                                                </span>
                                            </div>
                                        </div>


                                    </div>


                                </div>
                                <p class="my-0 wd-notif-blc-sep-label"
                                   [routerLink]="['/view-task',task['_id']]">
                                    Broj: {{task['identifier']}}</p>
                            </div>


                        </div>


                    </div>

                </div>
                <div class="board-example-container">
                    <div [ngStyle]="{'padding':newColumnButton?'0':'10px'}"
                         class="board-add-column-header board-add-column mr-3 overflow-hidden"
                         [ngClass]="{'input-group':newColumnButton===true }">
                        <div *ngIf="newColumnButton==false" id="notClicked">
                            <div>
                                <button type="button"
                                        style="color:#a6a2a2 !important;"
                                        class="btn full-width no-padding no-border board-column-name"
                                        (click)="newColumnButton= !newColumnButton"
                                        *ngIf="!newColumnButton">+
                                    Dodaj kolonu
                                </button>

                            </div>

                        </div>


                        <input *ngIf="newColumnButton===true" type="text" placeholder="IME KOLONE" id="newColumn"
                               [(ngModel)]="newColumnName">
                        <div *ngIf="newColumnButton===true" class="input-group-append">
                            <button style="font-size: 14px;
    position: fixed;color: forestgreen;"
                                    class="btn"
                                    type="button"
                                    (click)="addColumn(id)">
                                <i style="font-weight: bolder"
                                   class="lni lni-checkmark"></i>
                            </button>
                        </div>


                    </div>
                </div>

            </div>
        </div>


    </div>

</ng-scrollbar>

